import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	// remove when cleaning up "plan_wizard_accessible_button_labeling"
	close: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dialogLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	// remove when cleaning up "plan_wizard_accessible_button_labeling"
	close: {
		id: 'portfolio-3-create-new-plan-wizard-drawer.ui.close',
		defaultMessage: 'Close',
		description: 'Label for the button which closes drawer for create new plan wizard',
	},
	dialogLabel: {
		id: 'portfolio-3-create-new-plan-wizard-drawer.ui.dialogLabel',
		defaultMessage: 'Create a plan',
		description: 'Label for the dialog containing the create new plan wizard',
	},
});
export default messages;
